import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import styled from '@ihme/common/theme/styled';
import _ from '@ihme/common/locale';

import RouteChangeObserver from './RouteChangeObserver';
import Layout from '../components/Layout';
import HomeScene from '../scenes/HomeScene';
import GlobalImpactScene from '../scenes/GlobalImpactScene';
import TrendsScene from '../scenes/TrendsScene';
import BreakdownScene from '../scenes/BreakdownScene';
import FactsheetsScene from '../scenes/FactsheetsScene';

import {
    HOME_PATH,
    GLOBAL_IMPACT_PATH,
    TRENDS_PATH,
    BREAKDOWN_PATH,
    FACTSHEETS_PATH
} from './paths';

const Container = styled.div(({ theme }) => ({
    height: '100%',
}));

const LayoutRoute = ({ component: Component, title, ...rest }) => (
    <Route
        {...rest}
        render={props => (
            <Layout title={title}>
                <Component {...props} />
            </Layout>
        )}
    />
);

export default () => (
    <Router>
        <Container>
            <RouteChangeObserver />
            <LayoutRoute
                path={HOME_PATH}
                exact
                component={HomeScene}
                title={_('browser_title_home')}
            />
            <LayoutRoute
                path={GLOBAL_IMPACT_PATH}
                exact
                component={GlobalImpactScene}
                title={_('browser_title_global_impact')}
            />
            <LayoutRoute
                path={TRENDS_PATH}
                exact
                component={TrendsScene}
                title={_('browser_title_trends')}
            />
            <LayoutRoute
                path={BREAKDOWN_PATH}
                exact
                component={BreakdownScene}
                title={_('browser_title_breakdown')}
            />
            <LayoutRoute
                path={FACTSHEETS_PATH}
                exact
                component={FactsheetsScene}
                title={_('browser_title_factsheets')}
            />
        </Container>
    </Router>
);
